import { NDATemplate } from 'models/Nda';
import { getSortComparator } from 'utils';

export const sortNdaTemplates = (templates: NDATemplate[]) =>
  templates.sort((a, b) =>
    getSortComparator(a.name.toLowerCase(), b.name.toLowerCase()),
  );

export const filterNdaTemplates = (templates: NDATemplate[], id: string) =>
  templates.filter(({ templateId }) => id !== templateId);
